var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hl-wid ww2 whx1 ubox" }, [
    _c("div", { staticClass: "ub-head mb" }, [
      _c("h2", [
        _vm._v(_vm._s(_vm.item.id ? "Edit" : "New") + " " + _vm._s(_vm.entity))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "ubh-ico user" })
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "user-form login",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.saveProfile($event)
          }
        }
      },
      [
        _c("div", { staticClass: "uf-row split" }, [
          _c("div", [
            _c("label", [_vm._v("Title")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.item.title,
                  expression: "item.title"
                }
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.item.title },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item, "title", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "uf-row to-c" }, [
      _c("button", { staticClass: "main" }, [_vm._v("Update")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }